import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import PlainEditor from "../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import { useContentDt } from "../../gallery/scripts/useContentDt.js";
import ButtonV2 from "shared/ui/ButtonV2/ButtonV2.js";
import "./styles.css";
export default function Description(props) {
    const text = props.DTContext ? useContentDt(props.value, props.DTContext) : props.value;
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape")
                props.onLeave();
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [props.onLeave]);
    return ReactDOM.createPortal(React.createElement("div", { className: "description-overlay", onClick: props.onLeave },
        React.createElement("div", { className: "description-container", onClick: (e) => e.stopPropagation() },
            React.createElement("div", { className: "description-closing-container" },
                React.createElement("h3", null, "Kontakt"),
                React.createElement(ButtonV2, { className: "description-closing", onClick: props.onLeave, variant: "ghost" }, "\u2716")),
            React.createElement(PlainEditor, { onChange: () => { }, editable: false, example: text, update: text, label: "" }))), document.querySelector("#consent-description-container"));
}
